var _svg;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ReclutamientoDark = function ReclutamientoDark(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _svg || (_svg = /*#__PURE__*/_jsx("svg", {
      width: "24",
      height: "24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/_jsxs("g", {
        fill: "#49F2E1",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M12.1 15.3a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z"
        }), /*#__PURE__*/_jsx("path", {
          opacity: ".4",
          d: "M8.9 1h6.3v3.2c0 1.7-1.4 3.2-3.2 3.2-1.7 0-3.2-1.4-3.2-3.2L8.9 1ZM15.3 23.2H9V20c0-1.7 1.4-3.2 3.2-3.2 1.7 0 3.2 1.4 3.2 3.2l-.1 3.2ZM23.2 8.9v6.3H20c-1.7 0-3.2-1.4-3.2-3.2 0-1.7 1.4-3.2 3.2-3.2l3.2.1ZM1 15.3V9h3.2c1.7 0 3.2 1.4 3.2 3.2 0 1.7-1.4 3.2-3.2 3.2L1 15.3Z"
        })]
      })
    }))
  });
};
export default ReclutamientoDark;